<script>
export default {
    name: "ViewLabResults",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    props: {

        investigation: {
            type: Object,
            required: true,
        },
        results: {
            type: Object,
            required: true,
        },
        imageResults: {
            type: Array,
            required: true,
        },
        showModal: {
            type: Boolean,
            required: true,
        },
        routeParams: {
            type: Object,
            required: true,
        },
        viewPrintAll: {
            type: Boolean,
            default: true,
        },
    },

    methods: {

        printLabResult() {
            let url = `/medical-file/lab-result/print/`;
                url += `${this.investigation.patientId}/${this.investigation.code}`

            window.open(url, 
                '_blank', 
                `LabResultPrint`, 
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },

        printCombinedVisitInvestigations() {
            let url = `/medical-file/combined-visit-lab-results-print/print`;
                url += `/${this.investigation.patientId}/${this.investigation.visitNo}`;

            window.open(
                url, 
                '_blank', `LabPrint`,);
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-11/12 sm:w-full">
      <template v-slot:title>
        <h5 class="font-medium text-sm">View investigation Results</h5>  
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap -m-3">
            <div class="w-full flex flex-wrap p-1 bg-gray-300 my-1">
                <div class="md:w-1/6 w-1/2 p-1">
                    <h5 class="text-sm"><span class="font-medium">Id:</span> 
                        {{ investigation.acessionNo }} </h5>
                </div>
                <div class="md:w-1/4 w-1/2 p-1">
                    <h5 class="text-sm"><span class="font-medium">Investigation:</span> 
                        {{ investigation.test }}</h5>
                </div>
                <div class="md:w-1/5 w-1/2 p-1">
                    <h5 class="text-sm"><span class="font-medium">Requested By:</span> 
                        {{ investigation.requestedBy || `-` }}</h5>
                </div>
                <div class="md:w-1/6 w-1/2 p-1">
                    <h5 class="text-sm"><span class="font-medium">Done:</span> 
                        {{ investigation.done ? `Yes` : `No` }}</h5>
                </div>
                <div class="md:w-1/5 w-1/2 p-1">
                    <h5 class="text-sm"><span class="font-medium">Done Date:</span> 
                        {{ results.doneTime | dateFormat }}</h5>
                </div>
            </div>
            <ul class="flex border-b-2 border-gray-500">
              <li class="-mb-px mr-1">
                  <a href="javascript:void(0)" @click.prevent="active=0" 
                    class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                        px-4 font-bold whitespace-no-wrap" 
                    :class="active == 0 ? activeClass : inActiveClass">Component Results</a>
              </li>
              <li class="-mb-px mr-1">
                  <a href="javascript:void(0)" @click.prevent="active=1"
                    class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                        px-4 font-bold whitespace-no-wrap"
                    :class="active == 1 ? activeClass : inActiveClass">
                    <span 
                        class="p-1 rounded-full text-xs text-white bg-blue-800">
                            {{ imageResults.length }}</span>
                        Images</a>
              </li>
            </ul>
            <div class="w-full mt-px" v-if="active==0">
                <div class="w-full overflow-auto">
                    <table class="table table-hover">
                        <thead class="bg-blue-500 text-sm text-white">
                            <tr>
                                <th class="p-tiny">Component</th>
                                <th class="p-tiny">Value</th>
                                <th class="p-tiny">Min Value</th>
                                <th class="p-tiny">Max Value</th>
                                <th class="p-tiny">Unit</th>
                                <th class="p-tiny">Comment</th>
                            </tr>
                        </thead>
                        <tbody 
                            v-for="(result,idx) in results.componentResults" :key="idx"
                            class="bg-gray-100 text-xs overflow-auto">
                            <tr >
                                <td class="p-tiny">{{ result.component }}</td>
                                <td class="p-tiny">{{ result.resultValue }}</td>
                                <td class="p-tiny">{{ result.minValue }}</td>
                                <td class="p-tiny">{{ result.maxValue }}</td>
                                <td class="p-tiny">{{ result.description || `-` }}</td>
                                <td class="p-tiny">{{ result.comment || `-` }}</td>
                            </tr>
                            <tr>
                                <td colspan="6" class="p-tiny">
                                   <span class="font-bold">Description: </span> 
                                    {{ result.memo || `-` }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="w-full overflow-auto bg-gray-100 my-2">
                    <span v-html="results.resultsMemo"></span>
                </div>
            </div>
            <div class="w-full" v-if="active==1">
                <div class="w-full flex flex-col">
                    <div class="flex-1 p-tiny" v-for="(result, idx) in imageResults" :key="idx">
                        <iframe height="1300" width="1400" :src="`data:application/pdf;base64,${result.investigationImage}`" alt="lab test"></iframe>
                    </div>
                </div>
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button class="btn-sm btn-primary text-xs rounded mr-6" v-if="viewPrintAll"
            @click.prevent="printCombinedVisitInvestigations">
                <i class="fa fa-print"></i> Print Visit Investigations</button>
        <button class="btn-sm btn-primary text-xs rounded mr-6" 
            @click.prevent="printLabResult">
                <i class="fa fa-print"></i> Print</button> 
        <button 
            class="btn-danger btn-sm text-xs rounded" 
            @click.prevent="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Close</button>
      </template>
    </tail-modal>
</template>